import { OddsFormat, useAuthUserSettings } from '@/hooks/use-auth-user-settings';

// Get the user's odds format preference, defaulting to decimal. Classic Mode uses American odds.
export const useOddsFormat = () => {
    const { data: userSettings } = useAuthUserSettings();
    return userSettings?.odds_format ?? OddsFormat.DECIMAL;
};
